
import './App.css';
import HomePage from './Pages/Home/Index';

function App() {
  return (
    <div className="App">
     <HomePage/>
    </div>
  );
}

export default App;
